// extracted by mini-css-extract-plugin
export default {"qrcode":"QRCode_qrcode__sZZhq","qrcode__image":"QRCode_qrcode__image__C-2VR","qrcode__description":"QRCode_qrcode__description__JUVaP"};